import { useQuery } from "urql";

import {
  DashboardOutstandingPrincipalPerCollectionDocument,
  QueryDashboardOutstandingPrincipalPerCollectionArgs,
} from "../../../graphql/generated.ts";

export function useDashboardOutstandingPrincipalPerCollection(
  variables: QueryDashboardOutstandingPrincipalPerCollectionArgs
) {
  return useQuery({
    query: DashboardOutstandingPrincipalPerCollectionDocument,
    variables,
  });
}
